<template>
  <svg
    class="stroke-current"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.34375 10H17.6562"
      :stroke-width="props.strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.1875 15.4688L17.6562 10L12.1875 4.53125"
      :stroke-width="props.strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  strokeWidth?: number
}

const props = withDefaults(defineProps<Props>(), {
  strokeWidth: 1.5,
})
</script>
